import { render, staticRenderFns } from "./CardDevedor.vue?vue&type=template&id=55a5ac2c"
import script from "./CardDevedor.vue?vue&type=script&lang=js"
export * from "./CardDevedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports